import styled from 'styled-components'
import { fonts, colors, sizes, breakpoints } from '../../css-variables'

export default styled.h4`
    color: ${colors.buttonRed};
    font-size: 22px;
    width: 100%;
    text-align: center;
    margin-bottom: ${props => (props.open ? `32px` : 0)};
    font-family: ${fonts.redHatDisplay};
    font-weight: bold;
    font-size: ${sizes.s16};
    padding: ${sizes.s16} 0;
    text-transform: uppercase;

    @media screen and ${breakpoints.laptopS} {
        text-align: left;
        margin-bottom: 0;
        font-size: ${sizes.s18};
        padding: 0 0 ${sizes.s24};
    }

    a {
        color: ${colors.buttonRed};
        text-decoration: none;
    }

    button {
        color: inherit;
        background: none;
        border: none;
        font-size: ${sizes.s16};
        text-transform: uppercase;
    }
`
